import '@vebox/etui-system';
import '../../utilities/format-ms.js';
import '../../utilities/create-transition.js';
import { useContext, createElement } from 'react';
import '../../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, b as _extends } from '../../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import '../../Icon/Icon.js';
import '@vebox/etui-icons';
import '../../Icon/icons.js';
import '../../Icon/helper.js';
import '@vebox/etui-colors';
import '../../ErrorLabel/ErrorLabel.js';
import '../../FormItem/FormItem.js';
import '../../Input/Input.js';
import '../../InputLabel/InputLabel.js';
import TextInput from '../../TextInput/TextInput.js';
import '../../ClickOutside/ClickOutside.js';
import '../../Tooltip/Tooltip.js';
import '../../Button/Button.js';
import '../state/constants.js';
import { setValue } from '../state/actions.js';
import FilterPanelContext from '../FilterPanelContext.js';
import ApplyFilterButton from './ApplyFilterButton.js';
import { C as ControlRow } from '../../styles-14c01051.js';

const _excluded = ["field", "showApplyButton", "applyButtonLabel"];
const TextInputControl = _ref => {
  let {
      field,
      showApplyButton,
      applyButtonLabel
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    state,
    dispatch
  } = useContext(FilterPanelContext);
  return /*#__PURE__*/createElement(ControlRow, null, /*#__PURE__*/createElement(TextInput, _extends({
    key: field,
    id: field,
    value: state.toBeAppliedFilters[field] || '',
    onChange: event => dispatch(setValue(field, event.target.value)),
    styles: {
      root: {
        flex: 1
      }
    }
  }, rest)), showApplyButton && /*#__PURE__*/createElement(ApplyFilterButton, {
    field: field,
    applyButtonLabel: applyButtonLabel
  }));
};

export default TextInputControl;
